import { FC, memo } from 'react'
import Price from '../price'
import { DottedSeparator } from '../styles'
import { SideBarPaddingWrapper } from './styles'
import OwnerInfo from './owner-info'
import { DatePickerAlignment } from '../../common/date-picker/types'
import { FormattedContactDetails } from '../../../models/property-details-page/contact-model'
import { SearchbarFieldsReturn, UpdateSearchBarTransport } from '../hooks/use-searchbar'
import { FormattedBookingTypeData } from '../../../models/property-details-page/booking-type-model'
import { FormattedOfferTransport } from '../../../models/common/offers-model'
import { FormattedLivePricingDataTransport } from '../../../models/pricing/live-pricing-formatter'
import { PropertyDetails } from '../../../transports/property-details-page-transport'
import InquiryContactDetailsTransport from '../../../transports/inquiry-contact-details-transport'
import UserDetailsModel from '../../../models/user/user-details-model'
import { PdpToCheckoutPosition } from '../constants'

type SidebarProps = {
    trust?: Record<string, string | null>
    contact: FormattedContactDetails
    searchbar: SearchbarFieldsReturn
    updateSearchbar: UpdateSearchBarTransport
    availableDates: Date[] | null
    isAvailabilityLoading: boolean
    errorFetchingAvailability: Error | null
    pricingDetails: FormattedLivePricingDataTransport | null
    isPricingLoading: boolean
    pricingErrorCode: number | null
    bookingType: FormattedBookingTypeData | null
    offers: FormattedOfferTransport | null
    showVatTax: boolean
    providerId: PropertyDetails['providerId']
    responseTimeAverage?: number
    isTraumPaymentEnabled: boolean
    showCalendar: boolean
    maxTotalGuests?: number
    selectedUnitName: string
    selectDateIndicatorForComboListing?: boolean
    inquiryContactDetails: InquiryContactDetailsTransport | null
    userDetails: UserDetailsModel | null
    petsAllowed: boolean
}

const Sidebar: FC<SidebarProps> = ({
    trust,
    contact,
    searchbar,
    updateSearchbar,
    availableDates,
    isAvailabilityLoading,
    pricingDetails,
    pricingErrorCode,
    isPricingLoading,
    bookingType,
    offers,
    showVatTax,
    providerId,
    responseTimeAverage,
    isTraumPaymentEnabled,
    showCalendar,
    maxTotalGuests,
    selectedUnitName,
    selectDateIndicatorForComboListing = false,
    inquiryContactDetails,
    userDetails,
    petsAllowed,
}) => {
    return (
        <>
            <SideBarPaddingWrapper>
                <Price
                    datePickerAlignment={DatePickerAlignment.RIGHT}
                    layout="stretched"
                    searchbar={searchbar}
                    updateSearchbar={updateSearchbar}
                    availableDates={availableDates}
                    isAvailabilityLoading={isAvailabilityLoading}
                    pricingDetails={pricingDetails}
                    pricingErrorCode={pricingErrorCode}
                    isPricingLoading={isPricingLoading}
                    bookingType={bookingType}
                    offers={offers}
                    showVatTax={showVatTax}
                    isTraumPaymentEnabled={isTraumPaymentEnabled}
                    showCalendar={showCalendar}
                    position={PdpToCheckoutPosition.SIDEBAR}
                    maxTotalGuests={maxTotalGuests}
                    selectedUnitName={selectedUnitName}
                    selectDateIndicatorForComboListing={selectDateIndicatorForComboListing}
                    inquiryContactDetails={inquiryContactDetails}
                    userDetails={userDetails}
                    petsAllowed={petsAllowed}
                    showPriceWidget
                />
            </SideBarPaddingWrapper>
            <DottedSeparator />
            <OwnerInfo
                trust={trust}
                contact={contact}
                providerId={providerId}
                responseTimeAverage={responseTimeAverage}
                bookingType={bookingType}
            />
        </>
    )
}

export default memo(Sidebar)
